<template>
    <div id="app">
        <!-- <transition :name="transitionName">  -->
        <router-view class="Router" v-if="$route.name != 'Index' && $route.name != 'SessionEdit'" ref="gameInstance"></router-view>
        <!-- </transition> -->
        <transition :name="transitionName" v-if="$route.name != 'Login'"> 
            <keep-alive>
                <router-view v-if="$route.name == 'Index' || $route.name == 'SessionEdit'" class="Router"></router-view>
            </keep-alive>
        </transition>
        <toast v-if="showToast" :showToast="showToast"></toast>
        <loading v-if="showLoading" :showLoading="showLoading"></loading>
    </div>
</template>
<script>
import toast from './components/toast.vue';
import loading from './components/loading.vue';
export default {
    data: function(){
        return {
            showLoading: false,
            showToast: false,
            transitionName: 'slide-right',
        }
    },
    components: {
        toast,
        loading,
    },
    //监听路由的路径，可以通过不同的路径去选择不同的切换效果 
    watch: {
        '$route' (to, from) {
            // statistics.track("page_view");
            // consolelog(to);
            // this.gameInstance = to;
            // consolelog('现在路由:',to.path.split('/')[1],'来自路由:',from.path.split('/')[1],'现在的动画:',this.transitionName);
            // this.transitionName = to.name == 'Home' ? 'slide-left' : 'slide-right';
        }
    },
    created(){
        this.$bus.on('toast', this.toastFn);
        this.$bus.on('loading', this.LoadingFn);
    },
    methods: {
        LoadingFn(obj) {
            if (!(obj instanceof Object && obj.show)) {
                obj = false;
            }
            this.showLoading = obj;
        },
        toastFn(obj) {
            if (obj instanceof Object && obj.message) {
                if (!obj.duration || typeof obj.duration !== 'number') {
                    obj.duration = 1500;
                } // 默认1.5s后消失
                if (obj.duration < 10000) {
                    setTimeout(() => {
                        this.$bus.emit('toast', false);
                        obj.callback &&
                        typeof obj.callback === 'function' &&
                        obj.callback(); // 如果有成功的回调则执行
                    }, obj.duration);
                }
            } else {
                obj = false;
            }
            this.showToast = obj;
        },
    }
}
</script>
<style>
/* @import "../static/css/main.css";
@import "../static/css/color-dark.css";    深色主题 */
/* @import './element-variables.scss'; */

/* @import "../static/css/theme-green/color-green.css";   浅绿色主题 */
* {
    -webkit-tap-highlight-color: transparent;
    outline: none;
}
html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
    /* touch-action: none; */
}
.a{}
.el-picker-panel__shortcut {
    background-color: #eee;
    margin-bottom: 6px;
}
#app {
    width: 100%;
    height: 100%;
    /* background: #060c21; */
    /* background-image: repeating-linear-gradient(120deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6) 1px, transparent 1px, transparent 30px, rgba(255, 255, 255, 0.3) 30px, rgba(255, 255, 255, 0.3) 31px, transparent 31px, transparent 60px), repeating-linear-gradient(60deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6) 1px, transparent 1px, transparent 30px, rgba(255, 255, 255, 0.3) 30px, rgba(255, 255, 255, 0.3) 31px, transparent 31px, transparent 60px), repeating-linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3) 1px, transparent 1px, transparent 30px);
    background-size: 70px 120px; */
    background: radial-gradient(#1A5970 0%, #000 100%);
    overflow: hidden;
}
.Router {
    position: absolute;
    width: 100%;
    transition: all .8s ease;
    height: 100%;
}
.slide-left-enter,
 .slide-right-leave-active {
     opacity: 0;
    transform: translate(100%, 0);
}

.slide-left-leave-active,
.slide-right-enter {
     opacity: 0;
    transform: translate(-100% 0);
}
</style>


// WEBPACK FOOTER //
// src/App.vue